import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-tagesbericht-nu-legacy-form-bridge',
  templateUrl: './tagesbericht-nu-legacy-form-bridge.component.html',
  styleUrls: ['./tagesbericht-nu-legacy-form-bridge.component.scss']
})
export class TagesberichtNuLegacyFormBridgeComponent {}
